var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-30 w-full h-screen fixed top-0 left-0 flex items-center justify-center",class:_vm.variant && _vm.variant === 'black' ? 'bg-black' : 'bg-white'},[_c('span',{staticClass:"loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }